import type { ReactNode } from "react";

/** Заголовок-eyebrow серым над секцией (как у iOS Settings). */
export function SectionHeader({ children }: { children: ReactNode }) {
  return <div className="section-header">{children}</div>;
}

/** Группа в стиле iOS — белая карточка с разделителями внутри. */
export function Group({ children }: { children: ReactNode }) {
  return <div className="ios-group">{children}</div>;
}

/** Простая «толстая» карточка (одна, без вложенных строк) — для блоков описания. */
export function Card({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div className={`ios-card p-4 ${className}`}>
      {children}
    </div>
  );
}

/** Лидер-абзац под заголовком — крупный, серьёзный, с напором. */
export function Lead({ children }: { children: ReactNode }) {
  return (
    <p className="text-[17px] leading-relaxed text-ink font-medium">
      {children}
    </p>
  );
}

/** Подзаголовок секции внутри страницы. */
export function H3({ children }: { children: ReactNode }) {
  return <h3 className="text-[17px] font-bold text-ink tracking-tight mb-2">{children}</h3>;
}

/** Текст параграфа. */
export function P({ children }: { children: ReactNode }) {
  return <p className="text-[15px] leading-relaxed text-secondary">{children}</p>;
}

/** Цитата / выделение. */
export function Quote({ children }: { children: ReactNode }) {
  return (
    <div className="border-l-[3px] border-[var(--accent)] pl-4 text-[15px] leading-relaxed text-ink italic">
      {children}
    </div>
  );
}

/** Аккуратный «факт» — большое число + лейбл. Использует grid снаружи. */
export function Stat({ value, label }: { value: string; label: string }) {
  return (
    <div className="stat-tile">
      <div className="text-[24px] font-bold text-ink leading-none">{value}</div>
      <div className="text-[11px] text-muted leading-tight mt-1">{label}</div>
    </div>
  );
}

/** Чек-список преимуществ (зелёные галки). */
export function CheckList({ items }: { items: string[] }) {
  return (
    <ul className="space-y-2.5">
      {items.map((t, i) => (
        <li key={i} className="flex gap-3 items-start text-[15px] leading-snug text-secondary">
          <span className="text-[var(--icon-green)] font-bold flex-shrink-0 mt-0.5">✓</span>
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}

/** Список «не для тех, кто» (серые крестики). */
export function CrossList({ items }: { items: string[] }) {
  return (
    <ul className="space-y-2.5">
      {items.map((t, i) => (
        <li key={i} className="flex gap-3 items-start text-[15px] leading-snug text-muted">
          <span className="text-muted flex-shrink-0 mt-0.5">✕</span>
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}
